import styled from "styled-components"

export const BetReply = styled.div`
  display: grid;
  justify-content: space-between;
  grid-template-columns: 45% 45%;
  grid-column-gap: 20px;
`

export const BoardWrapper = styled.div`
  height: 130px;
  position: relative;
`
